import { render, staticRenderFns } from "./PhoneAppendsChip.vue?vue&type=template&id=2e4bf19c&"
import script from "./PhoneAppendsChip.vue?vue&type=script&lang=js&"
export * from "./PhoneAppendsChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports